import { render, staticRenderFns } from "./KlarnaPaymentSummaryModal.vue?vue&type=template&id=7507dd6e&"
import script from "./KlarnaPaymentSummaryModal.vue?vue&type=script&lang=js&"
export * from "./KlarnaPaymentSummaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports